export const fileUploaderConstants = {
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  MAX_FILE_COUNT: 1,
  MAX_FILE_NAME_LENGTH: 255,
  MAX_FILE_TYPE_LENGTH: 255,
  MAX_FILE_TYPE_COUNT: 1,
  MAX_FILE_TYPE_EXTENSION_LENGTH: 255,
  MAX_FILE_TYPE_EXTENSION_COUNT: 1,
  MAX_FILE_TYPE_MIME_TYPE_LENGTH: 255,
  MAX_FILE_TYPE_MIME_TYPE_COUNT: 1,

  AllowedImageFileTypes: [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    "image/bmp",
    "image/webp",
    "image/svg+xml",
  ],
  AllowedVideoFileTypes: ["video/mp4", "video/webm"],
  AllowedAudioFileTypes: ["audio/mp3", "audio/wav"],
  AllowedDocumentFileTypes: [
    "application/pdf",
    "application/msword",
    "application/vnd.ms-excel",
  ],

  //   image: ["png", "jpg", "jpeg"],
  //   video: ["mp4", "mov", "m4v", "avi", "wmv", "mpg", "mpeg", "3gp", "3g2"],
  //   audio: ["mp3", "wav", "aiff", "aac", "ogg", "wma", "m4a", "m4p", "m4b"],
  //   document: [
  //     "pdf",
  //     "doc",
  //     "docx",
  //     "xls",
  //     "xlsx",
  //     "ppt",
  //     "pptx",
  //     "txt",
  //     "csv",
  //     "rtf",
  //     "odt",
  //   ],
};
